import axiosInstance from "@/services/axiosInterceptor";

export async function getGuideAvailibilityById(id, date) {
  try {
    const response = await axiosInstance.get(`services/available-slots/${id}?date=${date}`);
    const data = response?.data.rows;
    return data;
  } catch (error) {
    throw error;
  }
}
